<!-- 产品类别 -->
<template>
  <BaseFormItem2
    class="board_type"
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup2 v-model="val" @change="handleEmit">
      <el-radio-button
        class="board_type__radio"
        v-for="item in options"
        :key="item.value"
        :label="item.value"
      >
        {{ item.label }}
        <img 
          v-if="item.value == 'ROGERS'"
          class="board_type__radio__new" 
          :src="require('@@/assets/img/icons/icon_new.png')" 
        />
      </el-radio-button>
      <el-radio-button
        class="board_type__radio"
        label="FPC"
        @click.native.prevent="handleClickFpc"
      >
        FPC
      </el-radio-button>
    </BaseRadioGroup2>
  </BaseFormItem2>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: String,
      default: 'FR-4'
    },
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getFR4Fields('board_type')
    },
    options() {
      return this.fields.options.filter(item => !['CEM-1', 'CEM-3', 'FR-1', '22F'].includes(item.value))
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    handleClickFpc() {
      // 新窗口打开FPC计价页
      window.open('/quote_new/fpc/')
    }
  }
}
</script>

<style lang="scss" scoped>
.board_type__radio {
  position: relative;
  .board_type__radio__new {
    position: absolute;
    top: -10px;
    right: 6px;
  }
}
</style>